/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { bucketObj } from "../../environment";
import countriesData from "../../core/json/countries.json";
import socialMediaData from "../../core/json/socialMedia.json"; 
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ImageWithBasePath, {uploadImageNewWithName, getImageName, uploadImageNew} from "../../core/img/imagewithbasebath";
import { toBlob  } from "html-to-image";
import ImageToVideoCanvas from "./ImageToVideoCanvas";
import { ReactPhotoCollage } from "react-photo-collage";

import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
  PlusCircle,
  X
} from "feather-icons-react/build/IconComponents";
import Spinner from "../loader/spinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import {setToogleHeader, set_store_list} from "../../core/redux/action";
import { useNavigate } from "react-router-dom";
import { APIgetStores } from "../../api/settings.ts";

const AddSocialSchedulingAi = () => {
  const route = all_routes;
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const [btnLoading, setBtnLoading] = useState(false);
  const choose = t?.[l]?.["choose"]
  const [collageSetting, setCollageSetting] = useState();
  const [selectedProducts, setSelectedProducts] = useState();
  const navigate = useNavigate();
  const [forceRender, setForceRender] = useState(0);
  const [isAutoPosting, setIsAutoPosting] = useState(false);


  let countriesOptions = [];
  const tenantId = localStorage.getItem("tenantWebId");
    console.log("tenantId1",tenantId)
  if(tenantId == "n4Xc96g6qyNcrq5dD" || tenantId == "jNrhXAynhAbQkrj8Y" || tenantId == "8wNWEtTEdgoywriNX" )
  {
    console.log("tenantId2",tenantId)
  
    countriesOptions = [
      { value: "select_country", label: "Select Country", name: "Select Country" },
      ...countriesData.filter(f=>f.value == "Japan").map(country => ({
          value: country.name,
          label: t?.[l]?.[country.name] || country.name
      }))
    ];
  }
  else
  {
    countriesOptions = [
      { value: "select_country", label: "Select Country", name: "Select Country" },
      ...countriesData.map(country => ({
          value: country.name,
          label: t?.[l]?.[country.name] || country.name
      }))
    ];
  }
  //tenantWebId
  
  const postingType = [ 
    { value: "normal", label: "Normal", name: "Normal" },
    { value: "collage", label: "Collage", name: "Collage" }
    // ,
    // { value: "reel", label: "Reel", name: "Reel" }
  ]
  const [allProductList, setAllProductList] = useState([])
  const [productList, setProductList] = useState([]);
  // const [collageUrl, setCollageUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [product, setProduct] = useState({})
  const [enabled, setEnabled] = useState(false)
  const [imgList2, setImgList2] = useState([])
  

  const store = useSelector((state) => [{label: choose, value: "choose"}].concat(state.store_list?.map((itm) => { return {label: itm.name, value: itm._id}})));

  const data = useSelector((state) => state.toggle_header);

  const prodData = useSelector((state) => state.gateway_edit)
  const [imageLoading] = useState(0)
  // socialMediaOptions
  let socialMediaOptionsData = [
    { value: "select_platform", label: "Select Platform", name: "Select platform" },
    ...(socialMediaData?.[Object.keys(socialMediaData)[0]] || []).map(p => ({
      value: p,
      label: t?.[l]?.[p] || p
    }))
  ];
  const [scheduleType, setScheduleType] = useState("daily");

  const [socialMediaOptions, setSocialMediaOptions] = useState([...socialMediaOptionsData]);
  const updateSocialMediaOptions = async (country, storeId) => {
    const platformsToUpdate = ["facebook", "instagram"];
    // add other plat forms only in json
    const updatePlatformOptions = async (platform) => {
      if (socialMediaOptions.some(option => option.value === platform)) {
        try {
          const result = await axios.get("getfbpagetokens", {
            params: {
              storeId: storeId,
              country: country,
              socialMediaType: platform,
            },
          });
  
          if (result.data.data) {
            // Extract new options
            const newOptions = result.data.data.map(pp => ({
              value: `${platform}-${pp.id}`,
              label: `${pp.name} (${platform})`,
            }));
  
            // Merge existing options with new ones
            setSocialMediaOptions(prevOptions => {
              const filteredOptions = prevOptions.filter(opt => opt.value !== platform);
              return [...filteredOptions, ...newOptions];
            });
  
            console.log(`Updated social media options for ${platform}:`, newOptions);
          }
        } catch (error) {
          console.error(`Error updating ${platform} options:`, error);
        }
      }
    };
  
    // Update each platform one by one
    for (let platform of platformsToUpdate) {
      await updatePlatformOptions(platform);
     // console.log("Updated socialMediaOptions:", socialMediaOptions); // May not reflect the latest changes
    }
  };
  
  const getStoreData = async () => {
    const res = await APIgetStores({});
    if (res?.response?.stores) {
      const storeData = res.response.stores.reverse();
      const storeOptions = storeData.map((store) => ({
        name: store.title,
        _id: store._id,
        storeCode: store.storeNumber, // Store code
      }));
      dispatch(set_store_list(storeOptions));
    }
  };
  
  const getProductData = async () => {
    const storeIds = localStorage.getItem("storeIds");
    if (!storeIds) return;
  
    let res = await axios.get("getuserinventory/", {
      params: {
        storeIds: storeIds,
      },
    });

    if (res.data.productList) {
      const productData = res.data.productList;
      const productOptions = productData.map((product) => ({
        name: product.name,
        _id: product._id,
        img: product.imgUrls?product.imgUrls[0]:null,
        imgList: product.imgUrls?product.imgUrls:null,
        storeId:product.storeId
      }));
      setAllProductList(productOptions);
    }
  };
  const getProductDataByStoreId = async (storeId) => {
    if (!storeId) return;
   
    let productOptions  = allProductList.filter(product => product.storeId === storeId);
    //{ value: "select_product", label: "Select Product", name: "Select Product" }

    setProductList([
      { value: "select_product", label: "Select Product", name: "Select Product" },
      ...productOptions.map((pp) => ({
        value: pp._id,
        imgSrc: pp.img.startsWith('http') ? pp.img : bucketObj.bucketUrl + bucketObj.objectKey + pp.img,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ImageWithBasePath
              src={pp.img.startsWith('http') ? pp.img :bucketObj.bucketUrl + bucketObj.objectKey + pp.img}
              alt={pp.img}
              absolutePath="true"
              className="img-fluid-phone-img"
              style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "5px" }}
            />
            <span style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
              {pp.name}
            </span>
          </div>
        ),
        name: pp.name,
        imgSrcList: pp.imgList.map(img => (img.startsWith('http') ? img :bucketObj.bucketUrl + bucketObj.objectKey + img))
      })),
    ]);
  };


  useEffect(() => {
    if (prodData?.viewOnly === true) {
      setEnabled(true);
      console.log("enabled", true);
    }
  }, [prodData?.viewOnly]);

  useEffect(() => {
    if (isAutoPosting) {
      handleInputChange({ target: { name: "storeId", value: "" } });
      handleInputChange({ target: { name: "storeName", value: "" } });
    }
  }, [isAutoPosting]);

  
  useEffect(() => {
    if(prodData) {
      setProduct( prodData )
    }
  }, [prodData])
  

  useEffect(() => {
    async function fetchData() {
      try {
        getStoreData();
        getProductData();

      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, [dispatch]);

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const goBack = () => {
    navigate("/socialmedia-scheduling-ai")
  }

  const submit= async (event) => {
    const form = event.currentTarget;
    event.preventDefault()
    event.stopPropagation()
    try {
      if(form?.checkValidity()) 
      {
        let resUrl = undefined;
        if(product.postingType == "collage")
        {
          resUrl = getImageName("ReactPhotoCollage.png", "socialmedia", 'img');
          console.log("resUrl",resUrl);
          await generateCollage(resUrl)
        }
       
       // resUrl
        
        if(product.postingType == "collage" ? resUrl:true)
        {
          setBtnLoading(true);
          try
          {
            const finalProduct = product; 
            if(finalProduct.scheduleTime)
            {
              finalProduct.isInstant = false;
              finalProduct.scheduleTime = finalProduct.scheduleTime
              ? finalProduct.scheduleTime
              : null;
          
              const now = new Date();
              console.log("finalProduct.scheduleTime",finalProduct.scheduleTime);
              now.setMilliseconds(0);
              now.setSeconds(0);
              now.setMinutes(now.getMinutes() + 10);
              
              // Ensure the selected date is not in the past
              if (finalProduct.scheduleTime && finalProduct.scheduleTime < now) {
                alert("You cannot select a past date or time.");
              }
            }
            else
              finalProduct.isInstant = true;

            if((product.platforms == 'facebook' || product.platforms == 'instagram') && !product.page)
            {
              alert("Please select page");
            }
            
            console.log("finalProduct",finalProduct);
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            finalProduct.userTimeZone = userTimeZone;
            finalProduct.postingUrl = resUrl;//collageUrl;
            finalProduct.reelUrl = videoUrl?videoUrl:undefined;
            finalProduct.aiPromptFromSheet = t?.[l]?.["post_ai_prompt"] || "Please write Socail media post, for 100 words max";
            finalProduct.auto = isAutoPosting;
            const res = await axios.post('addorupdatescheduledpostai/', finalProduct);
            if (res) {
              setBtnLoading(false);
              MySwal.fire({
              position: "top-end",
              icon: "success",
              title: "Post added Successfully!",
              showConfirmButton: false,
              timer: 3000,
              }).then(() => {
                  goBack();
              });
            }
          } catch (error) {
            setBtnLoading(false);
            console.log(error);
            MySwal.fire({
                position: "top-end",
                icon: "error",
                title: error.response.data.message,
                showConfirmButton: false,
                timer: 3000,
            });
          }
        }
      }
    } catch(e) {
      console.log(e)
      return false;
    }
    

    return false;
  }

  const generateCollage = async (name) => {
    const element = document.querySelector(".photo-collage");//(".photo-collage");sc-KXCwU
 
    if (element) {
      toBlob(element, { cacheBust: true })
      .then(async(blob) => {
        if (blob) {
      
          blob.name = "ReactPhotoCollage.png";
          let url = await uploadImageNewWithName(blob,name);
          console.log("Final url",url);
        }
      })
      .catch((error) => console.error("Screenshot failed:", error));
    }
  };

  const  handleInputChange = async(e) => {
    if(e?.target)//categoryId categoryName
    {
    const { name } = e.target;
    let { value } = e.target;

    if(name=='scheduleType')
      setScheduleType(value)


    const restrictedChars = /[%?\\/]/g;
    if( name == "title")
      value = value.replace(restrictedChars, "");
      setProduct(prevState => ({
        ...prevState,
        [name]: value
      }));
    
      console.log("e.target;",e.target);
     

      const { country,storeId } = product;//platforms,

    
    if(country  && name == 'storeId')
    {
      if(value !== '' && value !== null)
      {
        setSocialMediaOptions(null);
        setSocialMediaOptions([...socialMediaOptionsData]);
        //To do it is not refreshing
        console.log("SocialMediaOptions",socialMediaOptions);
        updateSocialMediaOptions(country,value);
      }
    }
    else if (storeId  && name == 'country')
    {
      updateSocialMediaOptions(value, storeId);
    }

    }
  };

  const handlePostingType = (posting)=> {
    console.log("posting: ",posting);
    if(posting == "collage" || posting == "reel")
    {
      handleProductSelection(selectedProducts);
      
    }
    else{
      setCollageSetting(null)
    }
  }

  async function handleFileUpload(event) {
      try {
      if(event.target.files.length) {
        const file = event.target.files[0];
         // Check the file size
         if (file.size > 5242880*4) {//5mb
          alert(t?.[l]?.["file_size_exceeds_20_mb_limit"] || "File size exceeds 5 MB limit");
          event.target.value = ''; // Clear the file input
          return;
      }
        let name = await uploadImageNew(file,'socailMediaScheduling','video');
        event.target.value = '';
        console.log("Video name",name);
        setVideoUrl(name);
        setProduct(prevState => ({
          ...prevState,
          reelUrl: name
        }));
      }
  
      } catch (error) {
        console.error('Error compressing image:', error);
      }
  }

  const handleRemoveProduct = () => {
    setVideoUrl(null);
    
    setProduct(prevState => ({
      ...prevState,
      // ["images"]: imgs,
      reelUrl: null,
    }));
  };
  
  const handleProductSelection = (product2) => {
   if(product2 && (product.postingType == "collage"))
    { 
      let imgList = [];
      let imgCount = 0;
      let layout1 = 2, layout2 = 2;      
      let height1 = "250px", height2 = "170px";
  
      if(product2.length == 1)
      {
        imgList = product2.flatMap(item => 
          item.imgSrcList.map(img => ({
            source: img
          }))
        );
        imgCount = product2[0].imgSrcList.length;
        layout1 = 1;
        layout2 = imgCount;
        height1 = "540px"
        height2 = "540px"
      }
      else
      {
        imgList = product2.map(item => ({ source: item.imgSrc }));
        imgCount = product2.length;
        if(imgCount==1)
        {
          layout1 = 1;
          layout2 = 1;
        } 
        else if(imgCount==2)
        {
          layout1 = 1;
          layout2 = 1;
        } 
        else if(imgCount==3)
        {
          layout1 = 1;
          layout2 = 2;
          height1 = "750px"
          height2 = "750px"
        }
        else if(imgCount==4)
        {
          layout1 = 2;
          layout2 = 2;
          height1 = "540px"
          height2 = "540px"
        }
      }

      const settings = {
        width: "100%",
        height: [height1, height2],
        // width: "600px",
        // height: ["250px", "170px"],
        layout: [layout1, layout2],
        photos: imgList,
        showNumOfRemainingPhotos: true,
      }
      console.log("settings",settings);
      setCollageSetting(settings);
      setForceRender((prev) => prev + 1);
     // generateCollage();
          
    } 
    else if(product2 && product.postingType == "reel")
    {
      console.log("reel")
      
  
      if(product2.length == 1)
      {
        const imgList3 = product2.flatMap(item => 
          item.imgSrcList.map(img => ({
            source: img
          }))
        );
        setImgList2(imgList3);
      }
      else
      {
        const imgList4 = product2.map(item => ({ source: item.imgSrc }));
        setImgList2(imgList4);
        
      }
     // generateCollage();
    }
    else
    {
      setCollageSetting(null)
    }
  };
 
  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t?.[l]?.["new_post"] || "New Post"}</h4>
              <h6>{t?.[l]?.["create_new_post"] || "Create new post"}
              </h6>
            </div>
          </div>
          <ul className="table-top-head">
            
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  {t?.[l]?.["back_to_post"] || "Back to Post"}
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        {/* /add */}
        <form onSubmit={submit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />

                          <span>{t?.[l]?.["post_information"] || "Post Information"}</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    <div className="addservice-info">
                       
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              <div className="col-lg-6 col-12 mb-3">
                              
                                  <div className="me-4">
                                    <label className="form-label">
                                      {t?.[l]?.["posting_type"] || "Posting Type"} <span>*</span>
                                    </label>
                                    <Select
                                      className="select"
                                      options={postingType}
                                      name="postingType"
                                      isDisabled={isAutoPosting}
                                      value={
                                        isAutoPosting
                                        ? postingType.find(option => option.value === "normal")
                                        : postingType.find(option => option.value === product.postingType) 
                                        || postingType[0]
                                      }
                                      onChange={(selectedOption) => {
                                        handleInputChange({ target: { name: "postingType", value: selectedOption.value } });
                                        handlePostingType(selectedOption.value)
                                      }}
                                      
                                    />
                                  </div>
                                  {/* {validationErrors.country && <p className="text-danger">{validationErrors.country}</p>} */}
                              </div>
                              <div className="col-lg-6 col-12 mb-3">
                                <div className="me-4">
                                  <label className="form-label">
                                    {t?.[l]?.["auto_posting"] || "Auto Posting"}
                                  </label>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="autoPostingCheckbox"
                                      checked={isAutoPosting}
                                      onChange={(e) => setIsAutoPosting(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="autoPostingCheckbox">
                                      {isAutoPosting ? "Enabled" : "Disabled"}
                                    </label>
                                  </div>
                                </div>
                              </div>

                            </div>  
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              {/* Product Name */}
                              <div className="col-lg-6 col-12 mb-3">
                              
                                  <div className="me-4">
                                    <label className="form-label">
                                      {t?.[l]?.["country"] || "Country"} <span>*</span>
                                    </label>
                                    <Select
                                      className="select"
                                      options={countriesOptions}
                                      name="country"
                                      value={countriesOptions.find(option => option.value === product.country) || countriesOptions[0]} // Default to the first country option if no match
                                      onChange={(selectedOption) => {
                                        handleInputChange({ target: { name: "country", value: selectedOption.value } });
                                      }}
                                      
                                    />
                                  </div>
                                  {/* {validationErrors.country && <p className="text-danger">{validationErrors.country}</p>} */}
                              </div>
                              <div className="col-lg-6 col-12 mb-3">
                                <div className="me-4">     
                                  <label className="form-label">{t?.[l]?.["store"] || "Store"} <span>*</span></label>
                                  <Select
                                    className="select"
                                    options={store}
                                    placeholder={choose}
                                    required
                                    value = {
                                      store?.filter(option => 
                                        option?.value === product.storeId)
                                    }
                                    onChange={(v) => {
                                      handleInputChange({target: {name: "storeId", value: v.value}});
                                      handleInputChange({target: {name: "storeName", value: v.label}});
                                      // getProductDataByStoreId(v.value);
                                      if (!isAutoPosting) {
                                        getProductDataByStoreId(v.value);
                                      }
                                    }} />
                                </div>
                              </div>
                            </div>

                            {!isAutoPosting && (
                              <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                          
                                <div className="col-lg-12 col-12 mb-3">
                                  <div className="me-4">
                                  <label className="form-label">
                                    {t?.[l]?.["select_product"] || "Select Product"} 
                                
                                  </label>

                                    <Select
                                      className="select"
                                      options={productList}
                                      name="product"

                                      isMulti
                                      value={productList.filter(option => product.product?.includes(option.value))}
                                      onChange={(selectedOptions) => {
                                      if (selectedOptions.length > 4) {
                                          alert("You can only select up to 4 products.");
                                          return;
                                        }
                                        handleInputChange({ 
                                          target: { name: "product", value: selectedOptions.map(option => option.value) } 
                                        });
                                        
                                        setSelectedProducts(selectedOptions)
                                        handleProductSelection(selectedOptions)
                                      }}
                                      
                                    />
                                    </div>
                                
                                </div>
                              </div>
                            )}
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              {/* Product Name */}
                            
                              <div className="col-lg-12 col-12 mb-3">
                                
                                <div className="me-4">
                                  <label className="form-label">
                                    {t?.[l]?.["platform"] || "Platform"} <span>*</span>
                                  </label>

                                  <Select
                                    className="select"
                                    options={socialMediaOptions}
                                    name="platforms"
                                    isMulti
                                    required
                                    value={socialMediaOptions.filter(option => product.platforms?.includes(option.value))}
                                    onChange={(selectedOptions) => {
                                      handleInputChange({ 
                                        target: { name: "platforms", value: selectedOptions.map(option => option.value) } 
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                            {product.postingType == "reel" &&   
                        <div className="col-lg-12 col-12 mb-3">
                          <div className="me-4">
                          <label className="form-label">
                            {t?.[l]?.["upload_video"] || "Upload Video"} 
                        
                          </label>
                          <ImageToVideoCanvas imageUrls={imgList2} onVideoGenerated={setVideoUrl} />
                          <div className="input-blocks">
                            <div className="image-upload">
                              <input type="file" 
                              accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/mkv"
                              onChange={handleFileUpload}
                              // disabled={isUploadLimitReached}
                              />
                              <div className="image-uploads">
                                <PlusCircle className="plus-down-add me-0" />
                                <h4>{t?.[l]?.["upload_video"] || "Upload Video"}</h4>
                              </div>
                            </div>
                            {imageLoading > 0 && <Spinner/>}
                          </div>
                          {videoUrl && 
                            <div className="phone-img border rounded p-2 position-relative" key={videoUrl}>
                              {/* Close Button */}
                              <Link
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent the default anchor behavior
                                  handleRemoveProduct();
                                }}
                                className="position-absolute top-0 end-0 m-2"
                              >
                                <X className="x-square-add remove-product text-danger" />
                              </Link>

                              {/* Video */}
                              <video
                                width="320"
                                height="200"
                                controls
                                className="img-fluid img-thumbnail"
                                style={{ maxWidth: '170px' }}
                              >
                                <source src={videoUrl.startsWith('http') ? videoUrl : bucketObj.bucketUrl + bucketObj.objectKey + videoUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            </div>

                            }
                          </div>
                        
                        </div>
                        }
                            </div>
     

                            <div>
                           
                              {collageSetting && product.postingType == "collage" &&    (
                                <div className="photo-collage">
                                    <ReactPhotoCollage key={forceRender} {...collageSetting} />
                                </div>
                                )
                              }
                            </div>
                           
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="me-4">
                            <label className="form-label">{t?.[l]?.["post_name"] || "Post Name"}</label>
                              <input
                                type="text"
                                placeholder={t?.[l]?.["post_name"] || "Post Name"}
                                className="form-control"
                                value={product.title}
                                required
                                name="title"
                                onChange={handleInputChange}
                                disabled={enabled}
                              />
                            </div>
                        </div>
                        

                               {/* Scheduling Options */}
                          <div className="col-lg-6 col-12 mb-3">
                            <div className="me-4">
                            <label className="form-label">
                              {t?.[l]?.["schedule_type"] || "Schedule Type"} <span>*</span>
                            </label>
                            <select
                              className="form-control"
                              value={product.scheduleType}                            
                              name="scheduleType"
                              onChange={handleInputChange}
                            >
      
                              <option value="none" name="name">{t?.[l]?.["select"] || "Select"}</option>
                              <option value="now" name="now">{t?.[l]?.["post_now"] || "Post Now"}</option>
                              <option value="daily" name="daily">{t?.[l]?.["daily"] || "Daily"}</option>
                              {/* <option value="weekly">{t?.[l]?.["weekly"] || "Weekly"}</option> */}
                              <option value="custom" name="custom">{t?.[l]?.["custom"] || "Custom"}</option>
                            </select>
                            </div>
                        </div>
                      </div>

                      <div className="row">
                 

                        {/* Select Date (Shown only for Weekly & Custom) */}
                        {scheduleType === "weekly" || scheduleType === "custom" ? (
                          <div className="col-lg-6 col-12 mb-3">
                            <label className="form-label">
                              {t?.[l]?.["schedule_date"] || "Schedule Date"} <span>*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={product.scheduleDate}
                              name="scheduleDate"
                              onChange={handleInputChange}
                              // onChange={(e) => setScheduleDate(e.target.value)}
                            />
                          </div>
                        ) : null}

                        {/* Select Time (Shown for Daily, Weekly & Custom) */}
                        {scheduleType === "daily" || scheduleType === "weekly" || scheduleType === "custom" ? (
                          <div className="col-lg-6 col-12 mb-3">
                            <label className="form-label">
                              {t?.[l]?.["schedule_time"] || "Schedule Time"} <span>*</span>
                            </label>
                            <input
                              type="time"
                              className="form-control"
                              value={product.scheduleTime}
                              name="scheduleTime"
                              onChange={handleInputChange}
                              // onChange={(e) => setScheduleTime(e.target.value)}
                            />
                          </div>
                        ) : null}
                      </div>

                      <div className="col-lg-12">
                      <div className="input-blocks summer-description-box transfer mb-3">
                         <div className="me-4">
                          <label className="form-label">{t?.[l]?.["suggestion"] || "Suggestion"}</label>
                          <textarea className="form-control" value={product.text || ""} name="text" onChange={handleInputChange}  maxLength={250} />
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
          
            </div>
          </div>
          {!enabled && (
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2" onClick={goBack}>
                {t?.[l]?.["cancel"] || "Cancel"}
              </button>
              <button type="submit" className="btn btn-submit">
                {t[l]?.[btnLoading ? "wait" : "save"] || [btnLoading ? "Wait..." : "Save"]}
              </button>

            </div>
          </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddSocialSchedulingAi;